import type { INovaEntity } from './base';
import type { CustomFieldType } from './custom-field';

export const SEMANTIC_LABEL_SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/u;

export interface ISemanticLabel extends INovaEntity {
  name: string;
  slug: string;
  description: string;
  assignableTypes: CustomFieldType[];
}
